import { createApolloClient, type TypePolicies } from '@base-app/web2'

// Single-record fields answered from the cache when the list already loaded that record, so a
// form opened from a list renders at once and only fetches when the record isn't cached.
const SINGLE_RECORD_FIELDS: Record<string, string> = {
  client: 'Client',
  application: 'Application',
  videoPlaylist: 'VideoPlaylist',
  video: 'Video',
  podcast: 'Podcast',
  radio: 'Radio',
  collaborator: 'Collaborator',
  collaboratorFunction: 'CollaboratorFunction',
  department: 'Department',
  location: 'Location',
  banner: 'Banner',
  event: 'Event',
  offering: 'Offering',
  feedPost: 'FeedPost',
}

export const typePolicies: TypePolicies = {
  // What the API computed for the signed-in user: each answer replaces the last, as a whole
  // (ViewerPermission has no id, so without this Apollo warns that data may be lost)
  Application: {
    fields: {
      viewerPermissions: { merge: false },
    },
  },
  Query: {
    fields: Object.fromEntries(
      Object.entries(SINGLE_RECORD_FIELDS).map(([field, typename]) => [
        field,
        {
          read(existing, { args, toReference }) {
            return (
              existing ??
              (args?.id ? toReference({ __typename: typename, id: args.id }) : undefined)
            )
          },
        },
      ]),
    ),
  },
}

export const apolloClient = createApolloClient(
  process.env.GQL_URL || 'http://localhost:3002/api/v1/graphql',
  { typePolicies },
)
